import { ParsedUrlQuery } from 'querystring';

export function getSearchPath(query: ParsedUrlQuery) {
    if (query['search-path']) {
        return query['search-path'];
    }

    return [];
}
